import { useEffect } from "react";
import { useState } from "react";
import { IDropdownPros } from ".";
import "./styles.scss";
import { MdArrowDropDown, MdModeEdit } from 'react-icons/md';
import { generateReactKey } from "@merchstores/shared/react/ReactKey";
import { useRef } from "react";

export const ActionDropdown = (props: IDropdownPros) => {

    const { title, list, className } = props;
    const [listOpen, setListOpen] = useState(false);
    const [headerTitle, setHeaderTitle] = useState(title);
    const [, setSelectedItem] = useState(null);
    const wrapperRef = useRef(null);


    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousemove', handleClickOutside);
        }
    });

    const toggleList = () => {
        setListOpen(!listOpen);
    }

    const closeList = () => {
        setListOpen(false);
    }

    const selectItem = (item: any) => {
        if (item) {
            setListOpen(false);
            if (item.action) {
                item.action();
            } else {
                setSelectedItem(item);
            }
        }

    }

    const handleClickOutside = (event: any) => {
        if (wrapperRef && wrapperRef.current && !wrapperRef.current.contains(event.target)) {
            closeList();
        }
    }


    return (
        <div className={`dd-container ${listOpen ? "open" : ""} `} id={""} ref={wrapperRef}>
            <button
                type="button"
                className={`dd-header rounded-md flex justify-center items-center text-merch-dark-gray font-bold ${className} `}
                onClick={toggleList}
            >
                <div className="dd-header-title">{headerTitle}</div>
                {!listOpen && <div className="desktop"><MdArrowDropDown /></div>}
                <div className="mobile"><MdModeEdit /></div>
            </button>
            {listOpen && (
                <div
                    role="list"
                    className="dd-list"
                >
                    <span className="dd-list-title" onClick={closeList}>{headerTitle}</span>
                    {list.map((item) => (
                        <button
                            type="button"
                            className="dd-list-item text-merch-dark-gray font-bold text-13 "
                            key={generateReactKey(item.id)}
                            onClick={() => selectItem(item)}
                        >
                            {item.title}
                            {' '}
                        </button>
                    ))}
                </div>
            )}
        </div>
    )

}